// extracted by mini-css-extract-plugin
export default {"home-page-link":"LandingPageLink__home-page-link___ieHPS","home-page-link__box":"LandingPageLink__home-page-link__box___YhHMY"};